// extracted by mini-css-extract-plugin
export const button = "Button-module--button--2t432";
export const outline = "Button-module--outline--25tTC";
export const loading = "Button-module--loading--dgqbx";
export const text = "Button-module--text--1ejO-";
export const buttonsWrapper = "Button-module--buttonsWrapper--2PUtg";